/**
 * Clases de una fila del sidebar. Viven acá y no en SidebarNav porque las
 * comparten el renderer del menú y el buscador (que en estado colapsado dibuja
 * una fila más, la de la lupa) y así no se desincronizan.
 */
export const ROW_CLASSES =
  "app-sidebar__row p-ripple flex align-items-center cursor-pointer border-round " +
  "text-700 hover:surface-100 transition-duration-150 transition-colors w-full no-underline";

/** BO-NAV-02 — resaltado del ítem activo. Ver .app-sidebar__row--active. */
export const ACTIVE_CLASS = "app-sidebar__row--active";
